import type AiCostFilterOptionsView from '@UI/Store/AiCosts/Views/AiCostFilterOptionsView';
import type AiCostsFilterView from '@UI/Pages/Administration/AiCosts/Filters/AiCostsFilterView';
import formatPeriodRange from '@UI/Pages/Administration/AiCosts/Helpers/formatPeriodRange';

const describeSubject = (filters: AiCostsFilterView, options: AiCostFilterOptionsView | null): string => {
	if (filters.isSubjectTab && filters.userId !== null) {
		return options?.users.find((user) => user.id === filters.userId)?.label ?? 'Utilisateur sélectionné';
	}

	if (filters.isSubjectTab && filters.facilityId !== null) {
		return (
			options?.facilities.find((facility) => facility.id === filters.facilityId)?.label ??
			'Agence sélectionnée'
		);
	}

	if (filters.isSubjectTab && filters.organizationId !== null) {
		return (
			options?.organizations.find((organization) => organization.id === filters.organizationId)
				?.label ?? 'Structure sélectionnée'
		);
	}

	if (filters.tab === 'organizations') {
		return 'Toutes les structures';
	}

	if (filters.tab === 'users') {
		return 'Tous les utilisateurs';
	}

	return 'Toutes les agences';
};

/** « Toutes les agences · du 1er au 23 octobre 2026 »: the filtered subject (or the generic one), then the period. */
const describeScope = (filters: AiCostsFilterView, options: AiCostFilterOptionsView | null): string => {
	return `${describeSubject(filters, options)} · ${formatPeriodRange(filters.from, filters.to)}`;
};

export default describeScope;
